/* @flow */
// typecheck: ignore file
import React from 'react';
import Image from 'components/Image.jsx';
import Text from 'components/Text.jsx';
import Modal from 'components/Modal.jsx';
import Button from 'components/Button.jsx';
import CenteredContainer from 'components/CenteredContainer.jsx';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import './styles/AdminSignupJoyrideModal.scss';

type Props = {
  onClose: () => void,
  onRequestHide: () => void,
  user?: {
    first_name: string,
  }
}

class AdminSignupJoyrideModal extends React.Component {
  props: Props;

  onClose = () => {
    this.props.onRequestHide();
    this.props.onClose();
  }

  render() {
    return (
      <Modal theme="light">
        <CenteredContainer>
          <div className="AdminSignupJoyrideModal">
            <Image src={require('assets/images/admin/onboarding-tour-illo.svg')} width={500} />
            <Text color="pitch" size="xxlarge">
              Welcome to Remind, {this.props.user ? this.props.user.first_name : '_ _ _ '}!
            </Text>
            <Text element="div" size="medium" color="thunder" className="AdminSignupJoyrideModal-info">
              Your teachers are already using Remind to communicate with their classes, clubs
              and teams. It‘s also great for school and district leaders, like you.
            </Text>
            <Button onClick={this.onClose}>
              Take a tour
            </Button>
          </div>
        </CenteredContainer>
      </Modal>
    );
  }
}

const withFirstName = graphql(gql`
  query {
    user: me {
      id
      first_name
    }
  }`, {
    props: ({ data }) => ({ user: data.user ? data.user : null }),
  }
);

export { AdminSignupJoyrideModal };
export default withFirstName(AdminSignupJoyrideModal);



// WEBPACK FOOTER //
// ./src/app/components/AdminSignupJoyrideModal.jsx